const pt = {
    root: ({ props }: { props: { invalid?: boolean } }) => ({
        class: [
            'inline-flex items-center w-full px-3 h-9 rounded-6',
            'border border-gray-200 bg-white text-sm',
            'transition-colors duration-fast cursor-pointer',
            'focus-within:border-teal focus-within:ring-2 focus-within:ring-teal/20',
            props.invalid && 'border-red'
        ]
    }),
    label: ({ props }: { props: { modelValue?: unknown } }) => ({
        class: [
            'flex-1 text-left truncate',
            // Placeholder text (no value selected) is muted; selected value uses normal text colour.
            props.modelValue == null || props.modelValue === '' ? 'text-gray-400' : 'text-gray-900'
        ]
    }),
    dropdown: { class: 'flex-none inline-flex items-center justify-center w-5 h-5 text-gray-400 ml-2' },
    clearIcon: { class: 'flex-none w-4 h-4 text-gray-400 hover:text-gray-700 ml-2 cursor-pointer' },
    overlay: {
        class: 'mt-1 bg-white border border-gray-200 rounded-6 shadow-shm z-dropdown overflow-hidden'
    },
    header: { class: 'p-2 border-b border-gray-200' },
    // Filter input (search-as-you-type) inside the open dropdown.
    // PrimeVue 4 Select wraps it in `pcFilterContainer` with InputText for the field
    // and a sibling icon container. Both pt key forms (`filter*` and `pcFilter*`) are
    // tried since PrimeVue's documented PT shape varies between minor releases.
    filterContainer: { class: 'relative block w-full' },
    filterInput: { class: '!pl-8' },
    filterIconContainer: {
        class: 'absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex items-center'
    },
    filterIcon: { class: 'w-4 h-4' },
    // Also expose nested pt for the inner Input/Container components — Select 4 forwards
    // a `pcFilter` slot which is the InputText composition. Adding pl-8 here ensures the
    // search icon has room regardless of which key path PrimeVue actually honors.
    pcFilterContainer: { class: 'relative block w-full' },
    pcFilter: {
        root: { class: '!pl-8' }
    },
    pcFilterIconContainer: {
        class: 'absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex items-center'
    },
    pcFilterIcon: { class: 'w-4 h-4' },
    list: { class: 'p-1 max-h-64 overflow-auto' },
    option: ({ context }: { context: { selected: boolean; focused: boolean } }) => ({
        class: [
            'px-3 py-2 text-sm rounded-4 cursor-pointer',
            context.selected && 'bg-teal-l text-teal-d font-semibold',
            !context.selected && context.focused && 'bg-gray-50',
            !context.selected && !context.focused && 'text-gray-900 hover:bg-gray-50'
        ]
    })
}

export default pt
